import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

const App = () => {
  // useEffect(() => {
  //   const disableRightClick = (event) => event.preventDefault();
  //   document.addEventListener("contextmenu", disableRightClick);

  //   return () => {
  //     document.removeEventListener("contextmenu", disableRightClick);
  //   };
  // }, []);
  return (
    <div>
      <Outlet />
      {/* <TwoFA/> */}
    </div>
  );
};

export default App;
